import React from "react";
import { Link } from "react-router-dom";
import img from "../../../assets/img/banner.png";
import binance from "../../../assets/img/binance.png";
import solidhash from "../../../assets/img/solidhash.png";
const Banner = () => {
	return (
		<section className="banner-section">
			<div className="container">
				<div className="banner-wrapper">
					<div className="banner-content">
						<h1 className="title">
							MULTI-CHAIN <strong>DECENTRALIZED</strong> LAUNCHPAD
						</h1>
						<p className="subtitle">
							Providing innovative platform for fundraising on Hepton
							Layer 2 Blockchain.
						</p>
						<div className="btn-grp">
							<Link to="#" className="cmn-btn">
								Connect Wallet
							</Link>
							<Link to="#" className="cmn-btn secondary-btn">
								Create Token
							</Link>
						</div>
						<div className="d-flex flex-wrap align-items-center trusted-partner">
							<h6 className="m-0 me-3">Trusted by:</h6>
							<Link to="#">
								<img src={binance} alt="" />
							</Link>
							<Link to="#">
								<img src={solidhash} alt="" />
							</Link>
						</div>
					</div>
					<div className="img">
						<img src={img} alt="" />
					</div>
					<div className="right-content">
						<div className="item">
							<h5>28.60%</h5>
							<span>Antexpad Staking Rol</span>
						</div>
						<div className="item">
							<h5>$100 Bilion</h5>
							<span>Fund Raised in the last 24 hours</span>
						</div>
						<div className="item">
							<h5>648+</h5>
							<span>IDO Projects in this blockchain</span>
						</div>
						<div className="item">
							<h5>28.60%</h5>
							<span>Antexpad Staking Rol</span>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Banner;
